<template>

    <div>
        <div class="form-check" v-for="option in options" :key="option">
            <label class="form-check-label"><input v-model="handler" :value="option" class="form-check-input" type="radio" @change="change"> {{ option }}</label>
        </div>
    </div>
</template>



<script>

export default {
  props: ['config', 'name', 'value'],
  data(){
      return {
          handler:'',
      }
  },
  computed:{
    options(){
        if(!this.config || !this.config.options) return {};
        if(Array.isArray(this.config.options)){
            var obj = {}
            for(var i in this.config.options){
                var value = this.config.options[i];
                obj[value] =value;
            }
            return obj;
        }
        return this.config.options;
    },
  },
  mounted(){
      this.handler = this.value;
  },
  methods:{
    change(){
        this.$emit('change',this.handler);
    },
  }

}
</script>
